import SaadaFirstCharge from '../pages/saada/FirstCharge/reducers'
import SaadaBDCenter from '../pages/saada/BD/pages/center/reducers'

export default {
  SaadaFirstCharge,
  SaadaBDCenter,
}
